module.exports = __webpack_public_path__ + "static/media/left_arrow_table.206bdf08.svg";